import { IOfferSpendAllLang } from '../../../types/lang'
import { offerSpendCrudModalLang } from './offerSpendCrudModal'
import { offerSpendPageLang } from './offerSpendPage'
import { offerSpendListTableLang } from './offerSpendListTable'
import { offerSpendByAccountListTableLang } from './offerSpendByAccountListTable'
import { offerSpendByOfferListTableLang } from './offerSpendByOfferListTable'
import { offerSpendByOfferDetailsTableLang } from './offerSpendByOfferDetailsTable'
import { offerSpendByOfferScopeListTableLang } from './offerSpendByOfferScopeListTable'
import { offerSpendByOfferScopeDetailsTableLang } from './offerSpendByOfferScopeDetailsTable'

export const offerSpendAllLang: IOfferSpendAllLang = {
	...offerSpendPageLang,
	...offerSpendCrudModalLang,
	...offerSpendListTableLang,
	...offerSpendByAccountListTableLang,
	...offerSpendByOfferListTableLang,
	...offerSpendByOfferDetailsTableLang,
	...offerSpendByOfferScopeListTableLang,
	...offerSpendByOfferScopeDetailsTableLang
}